import { Routes } from '@angular/router';

import { authGuard, guestGuard, roleGuard } from '@core/auth/guards';


export const routes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  {
    path: 'auth',
    canActivate: [guestGuard],
    loadChildren: () =>
      import('./features/auth').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'admin',
    canActivate: [authGuard, roleGuard(['ADMIN'])],
    data: {
      breadcrumb: {
        label: 'breadcrumb.home',
      }
    },
    loadComponent: () => import('@shell/admin-shell/admin-shell').then(m => m.AdminShell),
    loadChildren: () => import('@features/admin-features.routes').then(m => m.ADMIN_ROUTES)
  },
  {
    path: 'super-admin',
    canActivate: [authGuard, roleGuard(['SUPER_ADMIN'])],
    data: {
      breadcrumb: {
        skip: true,
      }
    },
    loadComponent: () => import('@shell/super-admin-shell/super-admin-shell').then(m => m.SuperAdminShell),
    loadChildren: () => import('@features/super-admin-features.routes').then(m => m.SUPER_ADMIN_ROUTES)
  },
  {
    path: 'broker',
    canActivate: [authGuard, roleGuard(['BROKER'])],
    data: {
      breadcrumb: {
        label: 'breadcrumb.home',
      }
    },
    loadComponent: () => import('@shell/broker-shell/broker-shell').then(m => m.BrokerShell),
    loadChildren: () => import('@features/broker-features.routes').then(m => m.BROKER_ROUTES)
  },
  {
    path: 'consultant',
    canActivate: [authGuard, roleGuard(['CONSULTANT'])],
    data: {
      breadcrumb: {
        label: 'breadcrumb.home',
      }
    },
    loadComponent: () => import('@shell/consultant-shell/consultant-shell').then(m => m.ConsultantShell),
    loadChildren: () => import('@features/consultant-features.routes').then(m => m.CONSULTANT_ROUTES)
  },
  {
    path: 'auto-inspector',
    canActivate: [authGuard, roleGuard(['AUTO_INSPECTOR'])],
    data: {
      breadcrumb: {
        label: 'breadcrumb.home',
      }
    },
    loadComponent: () => import('@shell/auto-inspector-shell/auto-inspector-shell').then(m => m.AutoInspectorShell),
    loadChildren: () => import('@features/auto-inspector-features.routes').then(m => m.AUTO_INSPECTOR_ROUTES)
  },
  {
    path: 'missing-permissions',
    canActivate: [authGuard, roleGuard(['UNKNOWN'])],
    loadComponent: () => import('@features/dashboard/pages/shared-pages/missing-permissions/missing-permissions.component').then(m => m.MissingPermissionsComponent),
  },
  {
    path: '**',
    loadComponent: () => import('@features/dashboard/pages/shared-pages/not-found/not-found.component').then(m => m.NotFoundComponent),
  }
];
